import { Component, computed, inject, input } from '@angular/core';
import { Failure } from '@libs/core/lib/state/failure';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'mtjr-error',
  template: `
    @if (effectiveMessage(); as message) {
      <div class="flex h-full flex-col items-center justify-center px-8 my-8">
        <img src="/assets/error.svg" class="size-[190px] dark:opacity-75" />
        <p class="text-medium/80 mt-4 text-center">{{ message }}</p>
      </div>
    }
  `,
})
export class VxErrorComponent {
  failure = input.required<Failure | undefined>();
  translateService = inject(TranslateService);

  effectiveMessage = computed(() => {
    const failure = this.failure();
    if (failure) {
      if ((failure.statusCode ?? 0) >= 500) {
        return this.translateService.instant('COMMON.SOMETHING_WENT_WRONG');
      }
      return failure.message;
    }
  });
}
